export const POSSIBLE_LANGUAGES = ["nl", "fr"];


// WEBPACK FOOTER //
// ./src/constants/languages.js